export interface StreetTarget {
  area_code?: string | null;
  street_code?: string | null;
  street_name?: string | null;
}

export const streetTargetValue = (street: StreetTarget): string => {
  const areaCode = String(street.area_code ?? '').trim();
  const streetCode = String(street.street_code ?? '').trim();

  return areaCode && streetCode
    ? `${areaCode}:${streetCode}`
    : String(street.street_name ?? '').trim();
};
